import React from "react";
import Drawer from "@mui/material/Drawer";
import SideBarContent from "./SideBarContent";

// Sidebar component to render the Drawer with sidebar content
const Sidebar = ({ openDrawer, userData, active }) => {
  return (
    <>
      <Drawer
        anchor="left" // Position the drawer on the left side
        open={true} // Keep the drawer open
        hideBackdrop={true} // Hide the backdrop overlay
        ModalProps={{ keepMounted: true }} // Keep the drawer mounted when not open
        variant="persistent" // Make the drawer persistent
        sx={{
          "& .MuiPaper-root": {
            marginTop: "70px", // Set margin from the top
            width: openDrawer ? "240px" : "80px", // Set width based on openDrawer state
            height: "calc(100vh - 64px)", // Set height to fit the screen excluding 64px (e.g., for a header)
            background: "var(--first-color)", // Set background color
            color: "var(--white-color)", // Set text color
            borderRight: "none", // Remove right border
            borderRadius: openDrawer
              ? "0px 0px 100px 0px" // Set border-radius for open state
              : "0px 0px 100px 0px", // Set border-radius for closed state
            transition: "width 0.8s ease", // Smooth transition for width change
          },
        }}
      >
        {/* Render the sidebar content */}
        <SideBarContent
          userData={userData} // Pass user data
          openDrawer={openDrawer} // Pass open drawer state
          active={active} // Pass active item
        />
      </Drawer>
    </>
  );
};

export default Sidebar;
